module.exports = __webpack_public_path__ + "static/media/letras.af21ed20.png";